/**
 * Reducer de tokens de sesión (access_token, refresh_token).
 *
 * Separado del reducer `user` a propósito: `user` responde "¿quién está
 * logueado?" y se usa en toda la UI (mostrar nombre, foto, etc.). `auth`
 * responde "¿con qué credenciales hablamos con la API?" — son conceptos
 * distintos que cambian en momentos distintos (el refresh actualiza solo
 * los tokens sin tocar el user; un futuro "editar perfil" actualiza el
 * user sin tocar los tokens).
 */
const initialState: { access_token: string | null; refresh_token: string | null } = {
  access_token: null,
  refresh_token: null,
};

const auth = (state = initialState, action: any) => {
  switch (action.type) {
    case 'SET_AUTH_TOKENS':
      return {
        access_token: action.payload.access_token,
        refresh_token: action.payload.refresh_token,
      };
    case 'CLEAR_AUTH_TOKENS':
      return initialState;
    default:
      return state;
  }
};

export default auth;
